<template>
  <div>
    <div
      class="d-flex flex-column flex-root"
      v-if="isAuthenticated"
      :style="pageLoadingStyle"
    >
      <!-- begin:: Header Mobile -->
      <KTHeaderMobile></KTHeaderMobile>
      <!-- end:: Header Mobile -->

      <!-- begin::Body -->
      <div class="d-flex flex-row flex-column-fluid page">
        <!-- begin:: Aside Left -->
        <KTAside v-if="asideEnabled"></KTAside>
        <!-- end:: Aside Left -->

        <div
          id="kt_wrapper"
          class="d-flex flex-column flex-row-fluid wrapper bg-off-white"
        >
          <!-- begin:: Header -->
          <KTHeader></KTHeader>
          <!-- end:: Header -->

          <!-- begin:: Content -->
          <div
            id="kt_content"
            class="content d-flex flex-column flex-column-fluid"
          >
            <!-- begin:: Content Head -->

            <!-- begin:: Content Head -->
            <KTSubheader
              v-if="subheaderDisplay"
              v-bind:breadcrumbs="breadcrumbs"
              v-bind:title="pageTitle"
            />
            <!-- end:: Content Head -->

            <!-- begin:: Content Body -->
            <div>
              <!-- <PageLoader :mode="page_loading"> </PageLoader> -->
              <v-app
                :style="{
                  background: $vuetify.theme.themes['light'].background,
                }"
              >
                <transition name="fade-in-up">
                  <router-view />
                </transition>
              </v-app>
            </div>
          </div>
          <KTFooter></KTFooter>
        </div>
      </div>
      <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>
      <KTScrollTop></KTScrollTop>
    </div>
    <PageLoader v-if="isLoading"> </PageLoader>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import PageLoader from "@/own/components/PageLoaderNew.vue";

export default {
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    KTScrollTop,
    PageLoader,
  },
  beforeMount() {
    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    // check if current user is authenticated
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  },
  computed: {
    page_loading: function () {
      return this.$store.getters.getPageLoading;
    },
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return false;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    isLoading() {
      return this.$store.getters.getPageLoading;
    },
    pageLoadingStyle() {
      if (this.isLoading) {
        return {
          filter: "blur(2px) brightness(0.55)",
          height: "100vh",
          overflow: "hidden",
          transition: "all 0.3s ease-in-out",
        };
      }
      return "";
    },
  },
};
</script>
<style scoped lang="scss">
.bg-off-white {
  background-color: #f7f7f9;
}
</style>
